import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-cookies-management',
  templateUrl: './cookies-management.component.html',
  styleUrls: ['./cookies-management.component.scss']
})
export class CookiesManagementComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<CookiesManagementComponent>
  ) { }
  ngOnInit(): void {
    this.dialogRef.disableClose = true;
  }  

  onNoClick(): void {
    this.dialogRef.close();
  }
}
